import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';

import modal from './modal/modalSlice';
import chain from './chain/chainSlice';
import presale from './presale/presaleSlice';
import stake from './stake/stakeSlice';
import tokens from './tokens/tokensSlice';
import deployedTokens from './deployedTokens/deployedTokensSlice';

const customizedMiddleware = getDefaultMiddleware({
  serializableCheck: false,
});

export const store = configureStore({
  reducer: {
    modal,
    chain,
    presale,
    stake,
    tokens,
    deployedTokens
  },
  middleware: customizedMiddleware,
  devTools: process.env.NODE_ENV !== 'production',
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
